import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Button, Collapse, Input } from "reactstrap";
import { getSettingByKey, toArray } from "../../../../helpers/common";
import { useNavigate } from "react-router-dom";

const EmploymentType = ({ searchParams }) => {
  const [toggleThird, setToggleThird] = useState(true);

  const navigate = useNavigate();

  const job_type = searchParams.getAll("job_type");

  const settings = useSelector((state) => state.settings.data);

  const jobTypeList = toArray(
    getSettingByKey(settings, "job_types")?.value,
    "\n"
  );

  const handleToggle = (value) => {
    const currentTypes = new Set(job_type);

    if (!currentTypes.has(value)) {
      currentTypes.add(value);
    } else {
      currentTypes.delete(value);
    }

    // Clear all job_type parameters and add new ones
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.delete("job_type");

    currentTypes.forEach((type) => {
      newSearchParams.append("job_type", type);
    });

    const newUrl = `${window.location.pathname}?${newSearchParams.toString()}`;
    navigate(newUrl);

    window.scrollTo({
      top: 250,
      behavior: "smooth",
    });
  };

  return (
    <div className="accordion-item mt-3">
      <h2 className="accordion-header" id="jobType">
        <Button
          className="accordion-button"
          onClick={(e) => {
            e.preventDefault();
            setToggleThird(!toggleThird);
          }}
          role="button"
          id="collapseExample"
        >
          Type of employment
        </Button>
      </h2>
      <Collapse isOpen={toggleThird}>
        <div className="accordion-body">
          <div className="side-title">
            {jobTypeList?.map((item, index) => (
              <div className="form-check mt-2" key={`job-type-${index}`}>
                <Input
                  className="form-check-input"
                  type="checkbox"
                  name="flexCheckboxDefault"
                  id={`${item}-flexCheckboxDefault`}
                  checked={job_type?.includes(item)}
                  onChange={(e) => handleToggle(item)}
                />
                <label
                  className="form-check-label ms-2 text-muted"
                  htmlFor={`${item}-flexCheckboxDefault`}
                >
                  {item}
                </label>
              </div>
            ))}
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default EmploymentType;
